module.exports = __webpack_public_path__ + "static/media/Dashboard_Selected.97b2284d.svg";